/**
 * The column set for a drill-down, by modal type — used by the modal to draw
 * the table and by the hook to build the export, so both see the same list.
 */
import { ModalType, POLineMetric } from '../types';
import { AnyRow, DrilldownColumn, DrilldownFormatters } from './columns';
import { grnColumns } from './grnColumns';
import { ncrColumns } from './ncrColumns';
import { poColumns } from './poColumns';
import { poLineColumns } from './poLineColumns';

/** Sheet / metric label when a drill-down opened without a cell label. */
export const MODAL_TYPE_LABEL: Record<Exclude<ModalType, ''>, string> = {
  po: 'Purchase Orders',
  pol: 'PO Lines',
  grn: 'GRNs',
  ncr: 'NCRs',
};

export interface ColumnOptions {
  /** The cell label the modal opened from ('Reject Value' widens the NCR money columns). */
  filterType?: string;
  /** PO-line drills: the cell's population ('qty_diff' adds a per-line Qty Diff column). */
  metric?: POLineMetric;
  /**
   * Supplier viewer: drop the customer's reporting-currency columns (converted
   * prices / totals, exchange rate) and the OTIF override flag — the same
   * columns the PO Lines and Deliveries grids withhold from suppliers, and the
   * fields the serializers strip from their payloads.
   */
  isSupplier: boolean;
}

export function columnsFor(
  type: ModalType,
  f: DrilldownFormatters,
  options: ColumnOptions,
): DrilldownColumn<AnyRow>[] {
  // Each factory is typed against its API row; the modal holds `unknown[]`.
  switch (type) {
    case 'grn':
      return grnColumns(f, options) as unknown as DrilldownColumn<AnyRow>[];
    case 'pol':
      return poLineColumns(f, options) as unknown as DrilldownColumn<AnyRow>[];
    case 'ncr':
      return ncrColumns(f, options) as unknown as DrilldownColumn<AnyRow>[];
    case 'po':
      return poColumns(f) as unknown as DrilldownColumn<AnyRow>[];
    default:
      return [];
  }
}
